/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Ad = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        position: {
            type: 'AdPositionEnum',
            isRequired: true,
        },
        start: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        stop: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        paused: {
            type: 'any-of',
            contains: [{
                type: 'boolean',
            }, {
                type: 'null',
            }],
        },
        url: {
            type: 'string',
            isRequired: true,
        },
        color: {
            type: 'any-of',
            contains: [{
                type: 'string',
                maxLength: 7,
                minLength: 7,
                pattern: '^#[0-9A-Fa-f]{6}$',
            }, {
                type: 'null',
            }],
        },
        priority: {
            type: 'number',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        imageMobile: {
            type: 'Image',
            isRequired: true,
        },
        imageDesktop: {
            type: 'Image',
            isRequired: true,
        },
        areasOfInterest: {
            type: 'array',
            contains: {
                type: 'AreaOfInterest',
            },
            isRequired: true,
        },
    },
} as const;
